// extracted by mini-css-extract-plugin
export default {"title":"styles_title__5Xk7Z","wrapper":"styles_wrapper__j+vpp","extra":"styles_extra__GjxRI","tags":"styles_tags__gOWl9"};